'use client'

import type { BasketError } from '../../_actions/checkBasketValidity'

import { FC } from 'react'

import { getClientEnvironment } from '@dfds-pax/common'

interface Props {
  basketError: BasketError
}

const BackendErrorsNonProd: FC<Props> = ({ basketError }) => {
  const environment = getClientEnvironment()

  if (environment === 'prod') return null
  return (
    <div
      className="fixed right-4 bottom-4 z-50 max-w-md rounded border border-red-400 bg-red-100 px-4 py-3 text-red-700"
      data-e2e="seabook-error"
    >
      {basketError?.errors && basketError.errors.length > 0 ? <label className="typography-heading-sm">Seabook error:</label> : null}
      <ul className="typography-body-md-regular text-semantic-global-text-default">
        {basketError?.errors?.map((e: any) => {
          return (
            <li key={e.code}>
              Backend code: {e?.code} - {e?.message}
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default BackendErrorsNonProd
